import styled from '@emotion/styled';

import { RequiredSectionTitle } from './RequiredSectionTitle';

import type { ChangeEvent, FunctionComponent } from 'react';

const StyledInput = styled.div({
    alignItems: 'center',
    alignSelf: 'stretch',
    background: '#FBFBFF',
    borderRadius: '0.625rem',
    boxSizing: 'border-box',
    display: 'inline-flex',
    gap: '0.375rem',
    height: '2.5rem',
    justifyContent: 'flex-start',
    outline: '0.0625rem #E7E7E7 solid',
    outlineOffset: '-0.0625rem',
    overflow: 'hidden',
    paddingBottom: '0.5rem',
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    paddingTop: '0.5rem',
    width: '100%',
});

const InputContainer = styled.div({
    width: '100%',
});

const InputField = styled.input({
    '&::placeholder': {
        color: '#9A9A98',
    },
    background: 'transparent',
    border: 'none',
    fontFamily: 'FT Regola Neue',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    outline: 'none',
    width: '100%',
});

type NewSkillTitleInputProps = {
    readonly onChange: (value: string) => void;
    readonly placeholder: string;
    readonly required?: boolean;
    readonly title: string;
    readonly value: string;
};

export const NewSkillTitleInput: FunctionComponent<NewSkillTitleInputProps> = ({
    onChange,
    placeholder,
    required = false,
    title,
    value,
}) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
        onChange(e.target.value);
    };

    return (
        <InputContainer>
            <RequiredSectionTitle required={required}>{title}</RequiredSectionTitle>
            <StyledInput>
                <InputField placeholder={placeholder} type="text" value={value} onChange={handleChange} />
            </StyledInput>
        </InputContainer>
    );
};
